<script>
	import { _ } from 'svelte-i18n';
</script>
<h2>Our Offer: Ticker "AION"</h2>

<p>We are the first Cardano Stake Pool physically localized in <strong>Poland</strong>. 
Our goal is to provide you with the highest ROI by any means necessary. More on that on <strong>{$_("goal")}</strong> panel.</p>

<p>Getting best from both two worlds with a backup node running on a cloud provider (Google) and main one living on bare metal setup:</p>
	<li>2X Xeon E5-2650v2 @ 2.60GHz (32 threads)</li>
	<li>SSD storage</li>
	<li>Uninterruptible Power Supply (UPS)</li>
	<li>32GB DDR3 Random-access memory</li>
	<li>With cutting edge <strong>Arch Linux</strong> distribution</li>

	<p>As a result, we bring up a valuable option for delegators. Stake Pool with <strong>high availability</strong> from a cloud provider, <strong>spatially</strong> spread with multiple nodes, <strong>distinctive origin</strong>, and increased <strong>geopolitical resilience</strong> thanks to our localization.</p>

<iframe width="500" height="360" frameborder="0" src="https://js.adapools.org/widget-dark.html?pool=a7b2a175b2e439acc125decd1f4d3a8e42a4744dcfe74dddf527c386"><a href="https://adapools.org/pool/a7b2a175b2e439acc125decd1f4d3a8e42a4744dcfe74dddf527c386">Detail</a></iframe>

<p>If you have any doubts if this the right choice, please see below our line of thought that inspired us to create a pool in the first place.</p>

<h2>Rationale</h2>

<p>The strength of a cryptocurrency lies in its decentralization which allows it to defend against various adversities such as:</p>
<li>Sybil attack - multiple malicious entities i.e. stake pools</li>
<li>DDoS - Distributed Denial of Service</li>
<li>51% attacks - when the majority of stake is in control of a few</li>

<p>As a delegator, you can improve Cardano's resilience by consciously delegating to pools that meet a few key criteria.  </p>

<h3>They do not rely solely on cloud providers (single point of failure)</h3>
<img src="single-point-of-failure.png" alt="Single Point of Failure" style="float:right;margin-top=30px" width="150px" class="img">
<p>Operators often go the path of least resistance by using virtual machines from Google Cloud, Amazon AWS, etc. This approach simplifies maintenance required, and guarantees high availability, but at cost of centralizing all pools that use those services. This creates a risk of being shut down by central authorities or even crippling networks by the unexpected downtime of server centers. Another drawback is missing hardware diversification since hardware-specific exploits are real possibilities.</p>

<h3>Improve decentralization by distinguishing themselves geographically and ethically</h3>
<img src="decentralization.png" alt="Decentralization" style="float:left;margin-top=30px" width="150px" class="img">
<p>Centralization comes with different aspects. Nontrivial examples that naturally come to mind aside from aggregating control and influence are hardware localization and software stack. But, often overlooked or neglected are ideology, ethnic origin, age, gender, religion, viewpoints, philosophy, language, you get the idea. Social diversity is a major factor in cryptocurrency success. The decentralized system used by all should be operated by many!  </p>

<h3>Are not oversaturated</h3>
<img src="saturation.png" alt="Oversaturation" style="float:right;margin-top=30px" width="150px" class="img">
<p>Current Ouroboros design - Cardano Proof of Stake consensus protocol - uses incentives in form of interest on delegated Ada. To maximize their yields pools should be by some margin short of saturation. Every stake pool with a chance to produce a block is at risk to produce more blocks than it will be rewarded for. Of course for small pools, these risks are very slim, but with more staked Ada risk also increase. Every block produced above the current threshold - determined by the d parameter - could be better used by other pools. And in a long run those occurrences lower overall ROI for this pool.</p>

<style>
	p {
		text-align: center;
		margin-left: 10px;
		margin-right: 10px;
	}
	img {
		margin-left: 10px;
		margin-right: 10px;
		filter:invert(80);
	}
	h3 {
		margin-top: 30px;
		font-size: 1.3em;
		color: lightseagreen;
	}
	h2 {
		margin-top: 30px;
		color: mediumpurple;
	}
	li {
		color: lavenderblush;
	}
	strong {
		color: azure;
	}

</style>

